import { render, staticRenderFns } from "./PaymentRequest.vue?vue&type=template&id=377694dc&scoped=true&"
import script from "./PaymentRequest.vue?vue&type=script&lang=js&"
export * from "./PaymentRequest.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRequest.vue?vue&type=style&index=0&id=377694dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377694dc",
  null
  
)

export default component.exports